import { useEffect, useState } from "react";

import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";

import { IFeedEntry } from "../../store/FeedEntry";

import mediumZoom from "medium-zoom";
import "react-medium-image-zoom/dist/styles.css";

import "./ImageCard.css";

interface IImageCardProps {
  feedEntry: IFeedEntry;
  hideEntry: Function;
  index: number;
  height: "100vh" | "80vh";
}

interface ImageWithHeight {
  height: number;
  image: string;
}

function ImageCard({ feedEntry, hideEntry, height, index }: IImageCardProps) {
  const imagesWithHeight = (images: string[]): ImageWithHeight[] => {
    return images.map((img) => {
      return {
        image: img,
        height: 0,
      };
    });
  };

  const [images, setImages] = useState(imagesWithHeight(feedEntry.images));

  const compareImageHeights = (a: ImageWithHeight, b: ImageWithHeight) => {
    return b.height - a.height;
  };

  const addImageHeight = (
    images: ImageWithHeight[],
    currentSrc: string,
    height: number
  ) => {
    console.log("Adding Image Height");
    let _images = images.map((img: ImageWithHeight) => {
      if (img.image === currentSrc) {
        return {
          image: img.image,
          height: height,
        };
      }
      return img;
    });
    _images.sort(compareImageHeights);
    return _images;
  };

  const onImgError = (target: any) => {
    hideEntry(index);
  }

  const onImgLoad = (target: any) => {
    if (images.length <= 1) return;
    const _images = addImageHeight(
      images,
      target.target.currentSrc,
      target.target.offsetHeight
    );
    if (_images !== images) {
      setImages(_images);
    }
  };

  useEffect(() => {
    setImages(imagesWithHeight(feedEntry.images));
  }, [feedEntry]);

  const zoomImage = (props: any) => {
    const zoom = mediumZoom(props.target.children[0], {
      background: 'rgba(0, 0, 0, 0.9)'
    });
    zoom.open();
  }

  return (
    <Carousel
      centerMode={true}
      centerSlidePercentage={100}
      showThumbs={false}
      showStatus={false}
      showIndicators={images.length > 1}
    >
      {images.map((img: ImageWithHeight, i: number) => {
        let image_source = img.image;
        if (img.image) {
          image_source = img.image.replaceAll('"', "");
        }
        return (
          <figure
            key={i}
            style={{
              backgroundColor: "black",
              transition: "transform 150ms ease-in-out",
            }}
            className="figure relative inline-block"
            onClick={zoomImage}
          >
            <img
              onLoad={onImgLoad}
              onError={onImgError}
              src={image_source}
              alt={feedEntry.title}
              style={{
                width: "auto",
                height: "auto",
                maxHeight: height,
                display: "block",
                maxWidth: "100%",
              }}
            />
          </figure>
        );
      })}
    </Carousel>
  );
}

export default ImageCard;
            //   <div className="hover-button bg-stone-700">
            //     <ArrowsPointingOutIcon
            //       onClick={() => {}}
            //       // className="right-4 absolute bottom-2 mx-auto text-9xl h-6 w-6 dark:text-white"
            //       style={{
            //         width: 25,
            //         height: 25,
            //         position: "absolute",
            //         bottom: 5,
            //         right: 5,
            //       }}
            //     />
            //   </div>
